import React from 'react';
import { Divider } from '@mui/material';
import {
  KeywordContent,
  KeywordWeight
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/api/apiTypes';
import { EditableContentCard } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/components/EditableContentCard';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { ContentCardSkeleton } from './LibraryReviewSkeletons';

export type AllBulletsComparisonProps = {
  currentContentPhrasesKeywords: Record<
    string,
    { phrases: KeywordContent[]; keywords: KeywordWeight[] }
  >;
  generatedContentPhrasesKeywords: Record<
    string,
    { phrases: KeywordContent[]; keywords: KeywordWeight[] }
  >;
  queryKey: readonly unknown[]; // Query key for data refetching and cache updates
  leftLoading?: boolean;
  rightLoading?: boolean;
};

export const AllBulletsComparison = ({
  currentContentPhrasesKeywords,
  generatedContentPhrasesKeywords,
  queryKey,
  leftLoading = false,
  rightLoading = false
}: AllBulletsComparisonProps) => {
  const getAllBulletIndices = () => {
    const indices: number[] = [];

    const allKeys = [
      ...Object.keys(currentContentPhrasesKeywords || {}),
      ...Object.keys(generatedContentPhrasesKeywords || {})
    ];

    allKeys.forEach((key) => {
      if (key.toLowerCase()?.startsWith('bullet ')) {
        const indexStr = key.split(' ')[1];
        const index = parseInt(indexStr, 10);
        if (!isNaN(index) && !indices.includes(index - 1)) {
          indices.push(index - 1);
        }
      }
    });

    return indices.sort((a, b) => a - b);
  };

  const bulletIndices = getAllBulletIndices();

  return (
    <>
      {bulletIndices.map((index) => (
        <React.Fragment key={`bullet-${index}`}>
          <Flex gap={16}>
            {leftLoading ? (
              <ContentCardSkeleton />
            ) : (
              <EditableContentCard
                title={`Bullet ${index + 1}`}
                content={currentContentPhrasesKeywords?.[`Bullet ${index + 1}`]?.phrases}
                side="current"
                fieldName={`currentContent.bullets.${index}`}
                queryKey={queryKey}
                placeholderText={`Missing required bullet ${index + 1}.`}
                isEditable={false}
              />
            )}
            {rightLoading ? (
              <ContentCardSkeleton />
            ) : (
              <EditableContentCard
                title={`Bullet ${index + 1}`}
                content={generatedContentPhrasesKeywords?.[`Bullet ${index + 1}`]?.phrases}
                side="generated"
                fieldName={`generatedContent.bullets.${index}`}
                queryKey={queryKey}
                placeholderText={`Missing required bullet ${index + 1}.`}
              />
            )}
          </Flex>
          <Divider sx={{ margin: '32px 0px' }} />
        </React.Fragment>
      ))}
    </>
  );
};

